var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightSubIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#A5A6BB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25837_220786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 3.375L3.5535 3.9105C3.64275 4.17858 3.89377 4.35938 4.17628 4.35938H5.67188V5.04188C4.5592 5.20134 3.70312 6.15553 3.70312 7.3125V8.29688C3.70312 8.478 3.85013 8.625 4.03125 8.625H7.96875C8.14988 8.625 8.29688 8.478 8.29688 8.29688V7.3125C8.29688 6.15553 7.4408 5.20134 6.32812 5.04188V4.35938H7.82372C8.10623 4.35938 8.35692 4.17858 8.44617 3.9105L8.625 3.375H3.375ZM6.65625 6.98438C6.65625 7.34695 6.36258 7.64062 6 7.64062C5.63742 7.64062 5.34375 7.34695 5.34375 6.98438C5.34375 6.6218 5.63742 6.32812 6 6.32812C6.36258 6.32812 6.65625 6.6218 6.65625 6.98438Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25837_220786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightSubIcon);
export default __webpack_public_path__ + "static/media/weight-sub-icon.319d5e34d06658846eabeb8b7eeea21f.svg";
export { ForwardRef as ReactComponent };